<template>
  <!-- NEWSLETTER MODAL -->
  <div class="modal" id="ra-modal" :class="{ visible: showModal }">
    <!-- STEP 1 -->
    <div class="frame" id="ra-modal-step1" :class="{ visible: isStepOne }">
      <div class="close ra-modal-close" v-on:click="closeModal">
        <i class="fa far fa-times"></i>
      </div>
      <h2>Get Updates</h2>
      <p>
        Confirm your registration for <br /><span id="ra-modal-email1"></span>
      </p>
      <div class="fields">
        <!-- First Name -->
        <input
          type="text"
          placeholder="First name"
          name="firstName"
          v-model="firstName"
          v-validate="'required'"
          :class="{ error: errors.has('firstName') }"
          autocomplete="given-name"
        />

        <!-- Last Name -->
        <input
          type="text"
          placeholder="Last name"
          name="lastName"
          v-model="lastName"
          v-validate="'required'"
          :class="{ error: errors.has('lastName') }"
          autocomplete="family-name"
        />

        <!-- Phone -->
        <input
          type="text"
          placeholder="Phone (optional)"
          name="phone"
          v-model="phone"
          autocomplete="tel"
        />
      </div>
      <button id="ra-modal-confirm" type="button" v-on:click="confirm">
        <span v-if="!isLoadingConfirm">Confirm</span>
        <span v-if="isLoadingConfirm">
          <i class="far fa-spinner-third fa-spin"></i>
        </span>
      </button>
    </div>

    <!-- STEP 2 -->
    <div class="frame" id="ra-modal-step2" :class="{ visible: !isStepOne }">
      <div class="close ra-modal-close" v-on:click="closeModal">
        <i class="fa far fa-times"></i>
      </div>
      <img
        src="https://www.wwf.org.au/images/UserUploadedImages/389/WWF_Logo_CMYK-01.svg"
        alt="WWF Logo"
      />
      <p>
        Your registration for <span id="aa-modal-email2">{{ email }}</span> is
        confirmed.
      </p>
      <button id="ra-modal-back" type="button" v-on:click="closeModal">
        Back to WWF
      </button>
    </div>
  </div>
</template>

<script>
import gtm from "../../utils/gtm";

export default {
  name: "Details",

  data: () => {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      isStepOne: true,
      isLoadingConfirm: false,
    };
  },
  props: {
    email: {
      type: String,
    },
    showModal: {
      type: Boolean,
    },
  },

  methods: {
    confirm() {
      this.isLoadingConfirm = true;
      this.$validator.validateAll().then(async (result) => {
        console.log("result", result);

        if (result) {
          const payload = {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            programName: this.$config.NEWSLETTERSUBSCRIBELIST,
            cookieID: this.$cookie.get("_mkto_trk"),
            ssoId: this.$store.getters.ssoId,
          };

          console.log("Newsletter payload", payload);

          await this.$store.dispatch("saveLead", {
            campaignId: "newsletter-signup",
            lead: payload,
          });

          console.log("Newsletter submit success");

          // GTM Event Success
          gtm.formSubmitSuccessEvent("newsletter-signup");

          this.isStepOne = false;
        } else {
          // GTM Event Failure
          gtm.formSubmitEvent("newsletter-signup");
        }

        this.isLoadingConfirm = false;
      });
    },
    closeModal() {
      this.isStepOne = true;
      this.isLoadingConfirm = false;

      // Reset form
      this.firstName = null;
      this.lastName = null;
      this.phone = null;

      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
button {
  height: 48px;
  padding: 0 calc(3 * var(--space));
  padding-bottom: calc(0.5 * var(--space));
  font-family: var(--font-secondary);
  font-size: 1.5em;
  text-transform: uppercase;
  color: #fff;
  background-color: var(--orange);
  border-radius: var(--border-radius);
  cursor: pointer;
}

input {
  margin-bottom: 0;
  height: 48px;
  font-size: 16px;
}

button:hover,
button:focus {
  background-color: var(--orange);
}

@media screen and (min-width: 1024px) {
  button {
    padding: 0 calc(1.5 * var(--space));
    padding-bottom: calc(0.25 * var(--space));
    font-size: 1.2em;
  }
}

/* NEWSLETTER */

input.error {
  border: 3px solid var(--wwfRed);
  box-shadow: unset;
}

/* NEWSLETTER MODAL */

.modal {
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.visible {
  display: flex;
}

.modal .frame {
  position: relative;
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 580px;
  margin: var(--space);
  padding: calc(4 * var(--space));
  padding-top: calc(6 * var(--space));
  background-color: #fff;
}

.modal .frame#ra-modal-step2 {
  gap: calc(3 * var(--space));
}

.modal .frame.visible {
  display: flex;
}

.modal .frame .close {
  position: absolute;
  top: calc(3.5 * var(--space));
  right: calc(4 * var(--space));
  cursor: pointer;
}

.modal .frame img {
  width: 110px;
}

.modal .frame p {
  font-size: 16px;
  line-height: 140%;
  text-align: center;
}

.modal .frame p span {
  color: var(--orange);
}

.modal .frame .fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.modal .frame button {
  width: 100%;
}

@media screen and (min-width: 1024px) {
  .modal .frame {
    gap: var(--space);
  }

  .modal .frame p {
    font-size: 1.2em;
  }

  .modal .frame button {
    width: auto;
  }
}
</style>


// WEBPACK FOOTER //
// Details.vue?b19fe1a0